import styled from "styled-components"
import { BookingInformationFormWrapper } from "../bookingInformationForm/styles"

export const PricingInformationFormWrapper = styled(BookingInformationFormWrapper)`
.containerItem {
		&:nth-child(odd) {
			border: none;
		}
	}
`
